import { Award, Star, MapPin, Sparkles } from 'lucide-react';
import { VIDEO } from '../../lib/constants';

const REASONS = [
  {
    icon: Award,
    title: 'Two Certified Systems',
    body:
      "We're certified in both YUMI and InLei — the only studio on Burrard Street that offers both. Your artist will recommend the right one for your lashes.",
  },
  {
    icon: Star,
    title: '3,300+ Five-Star Reviews',
    body:
      "Prép has over 3,300 verified Fresha reviews and 400+ Google reviews from Vancouver clients. We don't just do good lash lifts — we're consistent.",
  },
  {
    icon: MapPin,
    title: 'Downtown Vancouver Location',
    body:
      "We're at 1305 Burrard St — steps from Burrard SkyTrain, easy street parking, and walkable from the West End, Yaletown, and Davie Village.",
  },
  {
    icon: Sparkles,
    title: 'Full-Service Studio',
    body:
      'Book a lash lift alongside your hair appointment, brow lamination, or nail art. Prép is a full beauty parlour — your one-stop shop on Burrard St.',
  },
];

export const WhyPrep = () => {
  return (
    <section data-testid="why-prep-section" className="section-pad bg-brand-bg">
      <div className="container-prep">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-7">
            <p className="eyebrow mb-5">Why Prép</p>
            <h2 className="heading-2">
              Why Vancouver clients choose Prép
              <span className="italic block text-brand-gold">for their lash lift.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {REASONS.map(({ icon: Icon, title, body }, i) => (
            <div
              key={title}
              data-testid={`why-card-${i}`}
              className="group bg-brand-bgElev border border-brand-gold/15 rounded-3xl p-8 sm:p-10 hover:-translate-y-1 hover:border-brand-gold/40 hover:shadow-[0_20px_60px_-30px_rgba(201,169,110,0.5)] transition-all duration-500"
            >
              <div className="w-12 h-12 rounded-full bg-brand-gold/10 border border-brand-gold/30 flex items-center justify-center mb-6 group-hover:bg-brand-gold/20 transition-colors">
                <Icon size={18} className="text-brand-gold" />
              </div>
              <h3 className="font-serif text-2xl text-brand-cream mb-3">{title}</h3>
              <p className="text-brand-muted leading-relaxed">{body}</p>
            </div>
          ))}
        </div>

        {/* Salon video strip */}
        <div className="mt-16 relative aspect-[21/9] rounded-3xl overflow-hidden bg-brand-bgElev border border-brand-gold/15">
          <video
            src={VIDEO.salon.src}
            aria-label={VIDEO.salon.alt}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            className="w-full h-full object-cover"
            data-testid="why-salon-video"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-bg/85 via-brand-bg/20 to-transparent" />
          <div className="absolute bottom-6 left-6 sm:bottom-10 sm:left-10 text-brand-cream">
            <p className="eyebrow mb-2">Our Studio · Live</p>
            <p className="font-serif text-2xl sm:text-3xl">1305 Burrard St, Vancouver</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyPrep;
